import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Constants } from '../utils/constants';
import { ResizeService } from '../utils/resize.service';
import { UtmService } from '../utils/utm.service';

const isMobileDevice = (): boolean => {
  const agent = window.navigator.userAgent;
  return (
    agent.match(/Android/i) !== null ||
    agent.match(/webOS/i) !== null ||
    agent.match(/iPhone/i) !== null ||
    agent.match(/iPad/i) !== null ||
    agent.match(/iPod/i) !== null ||
    agent.match(/BlackBerry/i) !== null ||
    agent.match(/Windows Phone/i) !== null
  );
};

const isScreenSizeDesktop = (): boolean => window.innerWidth >= 992;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  registerButtonPath: String = Constants.registerButtonPath;
  formGenericUrl: string = Constants.formGenericUrl;
  currentLogoPath: String = Constants.fundacionJalaLogoPath;
  devFoundationButtonPath: String = Constants.devFoundationButtonPath;
  programButtonPath: String = Constants.devFoundationButtonPath;
  requirementsButtonPath: String = Constants.devFoundationButtonPath;
  faqInitialPath : String = Constants.faqButtonPath;
  faqButtonPath: String = Constants.faqButtonPath;
  faqFragment: String = Constants.faqFragment;
  programFragment: String = Constants.programFragment;
  requirementsFragment: String = Constants.requirementsFragment;
  skillSection: String = Constants.skillSection;
  private resizeSubscription?: Subscription;
  isMobileDevice = false;

  constructor(private route: ActivatedRoute, private utmService: UtmService, private resizeService: ResizeService) {
    this.isMobileDevice = !isScreenSizeDesktop() && isMobileDevice();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.utmService.setUtmSource(params.utm_source);
      this.utmService.setParams(params);
      const queryParams = this.utmService.getQueryParams();
      const { utm_source, utm_medium, utm_campaign } = queryParams;
      if (utm_source && utm_medium && utm_campaign) {
        const params = `?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`;
        this.programButtonPath = `${this.devFoundationButtonPath}${params}${this.programFragment}`;
        this.requirementsButtonPath = `${this.devFoundationButtonPath}${params}${this.requirementsFragment}`;
        this.faqButtonPath = `${this.faqInitialPath}${params}${this.faqFragment}`;
      } else {
        this.programButtonPath = `${this.devFoundationButtonPath}${this.programFragment}`;
        this.requirementsButtonPath = `${this.devFoundationButtonPath}${this.requirementsFragment}`;
        this.faqButtonPath = `${this.faqInitialPath}${this.faqFragment}`;
      }
      this.formGenericUrl = this.utmService.getFormPath()
    });
    this.resizeSubscription = this.resizeService.onResize$.subscribe(() => {
      this.isMobileDevice = !isScreenSizeDesktop() && isMobileDevice();
    });
  }

  ngOnDestroy(): void {
    this.resizeSubscription?.unsubscribe();
  }
  
  scrollAfterClick(): void {
    setTimeout(()=>{
      const headerHeight = document.getElementById('header').offsetHeight + 30;
      window.scrollBy({
        top: -headerHeight,
        behavior: 'smooth'
      });
    }, 100);
  }

  scrollToSkillSection(): void {
      window.scrollTo({
        top: document.getElementById(this.skillSection.toString()).offsetTop - document.getElementById('header').offsetHeight,
        behavior: 'smooth'
      })
  }
}
